import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { isProductionLikeEnvironment } from '../../utils/runtime-environment'

const captureError = (error) => {
  if (isProductionLikeEnvironment && Sentry) {
    Sentry.captureException(error)
  }
}

export const customQueryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      captureError(error)
    }
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      captureError(error)
    }
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 300000)
    },
    mutations: {
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000)
    }
  }
})
